/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RulesetDto } from './rulesetDto';
import { SimpleAirspaceJurisdictionDto } from './simpleAirspaceJurisdictionDto';
import { SimpleOrganisationDto } from './simpleOrganisationDto';

/**
 * The basic details of an authority type
 */
export interface SimpleAuthorityTypeDto {
    /**
     * The unique ID for this instance
     */
    id: number;
    /**
     * The name of this authority type
     */
    name: string;
    /**
     * The customised name for identifier
     */
    identifierLabel?: string;
    /**
     * Does the authority have an expiry date
     */
    hasExpiry: boolean;
    /**
     * This authority type will also record an identifier such as a serial number
     */
    hasIdentifier: boolean;
    /**
     * Does the authority type support multiple instances
     */
    hasMultipleInstances: boolean;
    /**
     * Is this a primary authority? if not it is secondary.
     */
    isPrimary: boolean;
    /**
     * Can the authority type have a workflow associated with it
     */
    hasWorkflow: boolean;
    /**
     * The customised name for authority type
     */
    abbreviation?: string;
    /**
     * Is this authority type requires approval
     */
    requiresApproval: boolean;
    /**
     * The organisation that issues the authority
     */
    issuedBy: SimpleOrganisationDto;
    /**
     * How/when/by who is the authority issued?
     */
    issuingMechanism: SimpleAuthorityTypeDto.IssuingMechanism;
    /**
     * Should this authority type be hidden in the UI from creation
     */
    hidden: boolean;
    /**
     * Can the authority have a name set by the user
     */
    hasName: boolean;
    /**
     * The type of organisation that this authority applies to
     */
    appliesTo: SimpleAuthorityTypeDto.AppliesTo;
    /**
     * Help text that describes how to get this authority type
     */
    helperText: string;
    /**
     * A short description of the authority type
     */
    description: string;
    /**
     * What kind of activity is this applicable to
     */
    activityType?: SimpleAuthorityTypeDto.ActivityType;
    /**
     * The date when the authority type was discontinued
     */
    discontinueDate?: string;
    /**
     * The message to display on the discontinued authority type
     */
    discontinueMessage?: string;
    /**
     * The associated jurisdiction of an authority type
     */
    jurisdiction?: SimpleAirspaceJurisdictionDto;
    /**
     * The ruleset the authority type operates under
     */
    ruleset?: RulesetDto;
    /**
     * What authority types need to exist before being able to add an instance of this authority type?
     */
    dependentOnAuthorityType?: SimpleAuthorityTypeDto;
}
export namespace SimpleAuthorityTypeDto {
    export type IssuingMechanism =
        | 'SELF_REPORTED'
        | 'ISSUER'
        | 'AUTOMATIC'
        | 'SELF_ISSUED';
    export const IssuingMechanism = {
        SELF_REPORTED: 'SELF_REPORTED' as IssuingMechanism,
        ISSUER: 'ISSUER' as IssuingMechanism,
        AUTOMATIC: 'AUTOMATIC' as IssuingMechanism,
        SELF_ISSUED: 'SELF_ISSUED' as IssuingMechanism
    };
    export type AppliesTo = 'PERSONAL' | 'COMMERCIAL' | 'RPA';
    export const AppliesTo = {
        PERSONAL: 'PERSONAL' as AppliesTo,
        COMMERCIAL: 'COMMERCIAL' as AppliesTo,
        RPA: 'RPA' as AppliesTo
    };
    export type ActivityType = 'COMMERCIAL' | 'NON_COMMERCIAL';
    export const ActivityType = {
        COMMERCIAL: 'COMMERCIAL' as ActivityType,
        NON_COMMERCIAL: 'NON_COMMERCIAL' as ActivityType
    };
}
